import axios from '@/utils/axios'
import { AxiosPromise } from 'axios'

/**
 * Profile request
 *
 * @param params
 */
export const index = (params = {}): AxiosPromise => {
  return axios.get('/withdrawals', { params })
}

/**
 * Update attribute
 *
 * @param id
 * @param params
 */
export const updateAttribute = (id: number, params = {}): AxiosPromise => {
  return axios.put(`/withdrawals/${id}/attribute`, params)
}

export const processed = (id: number, params = {}): AxiosPromise => {
  return axios.put(`/withdrawals/${id}/processed`, params)
}

export const rejectRow = (id: number, params = {}): AxiosPromise => {
  return axios.put(`/withdrawals/${id}/reject`, params)
}

/**
 * @param id
 */
export const destroy = (id: number): AxiosPromise => {
  return axios.delete(`/withdrawals/${id}`)
}
